import React from 'react';
import { object, array, func, bool, string, number } from 'prop-types';
import onWindowResize from 'library/hoc/on-window-resize';
import withScreenSizes from 'util/hoc/with-screen-sizes';
import {
  StyledFilterDescription,
  StyledFilterDropdown,
  StyledFilterMobileContainer,
  StyledMobileFilterRow,
} from 'apps/journey/pages/career-exploration/components/filters/styled-filter-dropdown';
import FilterType from './filter-types';

const FilterDropdown = ({
  filterName = 'filterName',
  filterInfo,
  options,
  filterType,
  filters = [],
  multiselect = true,
  handleFilterUpdate = () => null,
  windowWidth,
  screenSizes,
}) => {
  const mapFilterOption = (filterOption, index) => (
    <FilterType
      key={filterType + index}
      filterOption={filterOption}
      filterIndex={index}
      filterType={filterType}
      filters={filters}
      handleFilterUpdate={handleFilterUpdate}
    />
  );

  const filterActive = filters.length > 0;

  return windowWidth > screenSizes.tablet ? (
    <StyledFilterDropdown
      name={filterName}
      description={
        !!filterInfo && (
          <StyledFilterDescription filterActive={filterActive}>
            {filterInfo}
          </StyledFilterDescription>
        )
      }
      placeholder={filterName}
      placeholderOnly={true}
      multiselect={multiselect}
      carrot={false}
      filterActive={filterActive}
      contentClassName="dropdown-filter-content"
    >
      {options.map(mapFilterOption)}
    </StyledFilterDropdown>
  ) : (
    <StyledFilterMobileContainer>
      <StyledMobileFilterRow>
        {!!filterInfo && (
          <StyledFilterDescription>{filterInfo}</StyledFilterDescription>
        )}
        <div>{options.map(mapFilterOption)}</div>
      </StyledMobileFilterRow>
    </StyledFilterMobileContainer>
  );
};

FilterDropdown.propTypes = {
  filterName: string,
  filterInfo: string,
  filterType: string,
  options: array,
  filters: array,
  multiselect: bool,
  handleFilterUpdate: func,
  windowWidth: number,
  screenSizes: object,
};
export default withScreenSizes(onWindowResize(FilterDropdown));
